import { render, staticRenderFns } from "./zhuce.vue?vue&type=template&id=6905d5a4&scoped=true"
import script from "./zhuce.vue?vue&type=script&lang=js"
export * from "./zhuce.vue?vue&type=script&lang=js"
import style0 from "./zhuce.vue?vue&type=style&index=0&id=6905d5a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6905d5a4",
  null
  
)

export default component.exports